/* eslint-disable react/jsx-no-literals */

import * as React from "react";
import { Button } from "web-ui";

import { FooterLinksResponsive } from "./Footer";
import imageAppleLogo from "./images/apple-logo.svg";
import imageLogoMath from "./images/logo-math.svg";
import styles from "./styles/Math.module.scss";
import MetaDescription from "./util/components/MetaDescription";
import { useWordpressPageAllData } from "./util/hooks/useWordpressPage";

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
interface Props {
  id: number;
  // eslint-disable-next-line  @typescript-eslint/consistent-indexed-object-style
  className?: string;
}

const MobileHeader = () => (
  <div className={styles["mobile-header"]}>
    <img alt="Duolingo" className={styles["hero-logo"]} src={imageLogoMath} />
  </div>
);

const DesktopHeader = ({
  appStoreQRcode,
  appStoreUrl,
}: {
  appStoreQRcode: string;
  appStoreUrl: string;
}) => (
  <div className={styles["desktop-header-sticky"]}>
    <nav className={styles["top-header"]}>
      <div className={styles["header-imgs"]}>
        <img
          alt="Duolingo"
          className={styles["hero-logo"]}
          src={imageLogoMath}
        />
        <div className={styles.cta}>
          <img
            alt="Duolingo Math"
            className={styles["hero-logo"]}
            src={`data:image/svg+xml;utf8,${encodeURIComponent(
              appStoreQRcode,
            )}`}
          />
          <a href={appStoreUrl} rel="noreferrer" target="_blank">
            <Button
              className={styles["download-button"]}
              color="macaw"
              variant="solid"
            >
              <img src={imageAppleLogo} /> Download on the App Store
            </Button>
          </a>
        </div>
      </div>
    </nav>
  </div>
);

const MathLandingPage = ({ id }: Props) => {
  const wordpressData = useWordpressPageAllData(id);
  const html = wordpressData.content?.rendered;
  const appStoreUrl = wordpressData.app_store_url;
  const appStoreQRcode = wordpressData.app_store_qr_code;

  return (
    <div className={styles.page}>
      <MetaDescription
        content="Duolingo Math makes it easy—and fun!—for adults and students to learn foundational math skills!"
        title="Duolingo Math - Free math lessons and brain training"
      />
      <DesktopHeader
        appStoreQRcode={appStoreQRcode}
        appStoreUrl={appStoreUrl}
      />
      <MobileHeader />
      <div
        className={styles["body"]}
        // eslint-disable-next-line @typescript-eslint/naming-convention
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FooterLinksResponsive />
    </div>
  );
};

export default MathLandingPage;
